// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"dd2c44b8","578":"f1957705","763":"dd2c44b8","781":"bf9f91c3","837":"63718ad4","898":"dd2c44b8"}[chunkId] + ".chunk.css";
};